// Settings › Communication › E-mail (owner: communication): delivery, the system sender, mailbox access,
// logging mail in activities and a test message.
import { createFileRoute } from '@tanstack/react-router';
import { EmailSettingsPage } from '../../../features/comm-settings/EmailSettingsPage';

export const Route = createFileRoute('/_settings/settings/email')({ component: EmailSettingsPage });
